import { render, staticRenderFns } from "./BlockPriceList.vue?vue&type=template&id=23183a37&scoped=true"
import script from "./BlockPriceList.vue?vue&type=script&lang=js"
export * from "./BlockPriceList.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceList.vue?vue&type=style&index=0&id=23183a37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23183a37",
  null
  
)

export default component.exports